import type { PlanType } from '@adalo/constants'
import { PLAN_ERAS, PLAN_ERA_NONE, PAST_ERAS } from '@adalo/constants'
  
export const getPlanEra = (planType?: PlanType) => {
  if (!planType) {
    return PLAN_ERA_NONE
  }
  
  for (const eraId in PLAN_ERAS) {
    if (PLAN_ERAS[eraId] && PLAN_ERAS[eraId]?.includes(planType)) {
      return eraId
    }
  }
  
  return PLAN_ERA_NONE
}
  
export const isLegacyPlanType = (planType: PlanType): boolean =>
  PAST_ERAS.includes(getPlanEra(planType))
  